import * as Yup from 'yup';

export const validationSchemaForFilter = Yup.object({
  openDate: Yup.date().nullable(),
  closeDate: Yup.date().nullable(),
  invoiceApproverId: Yup.object({
    label: Yup.string(),
    value: Yup.string(),
  }).nullable(),
});
